import { useLayoutEffect } from 'react';
import { removeLink, upsertJsonLd, upsertMeta } from './headTags';
export type Robots = 'index, follow' | 'noindex, nofollow';
type Props = {
  title: string;
  robots: Robots;
};

/**
 * Titel en robots-regel voor een scherm dat niet via shop/seo loopt (het beheer).
 *
 * Dit is de **laatste** van drie lagen, niet de enige. Een bot die geen JavaScript draait,
 * ziet deze tag nooit. De echte afscherming zit op de server en werkt zonder JavaScript:
 * 1. `X-Robots-Tag: noindex, nofollow` op elk antwoord onder /be (één domein, utils/hosts.ts)
 *    (de regels komen uit `robotsHeaderRules()` in utils/seoFiles.ts);
 * 2. `Disallow` in robots.txt (zelfde bron);
 * 3. deze meta-tag, zodat ook een kopie zonder die server (zoals deze preview) niet indexeert.
 *
 * useLayoutEffect: de tag staat er vóór het eerste beeld, dus ook als een lazy deel daarna
 * mislukt. Het beheer heeft geen canonical en geen structured data: die van de shop gaan weg.
 */
export function DocumentHead({
  title,
  robots
}: Props) {
  useLayoutEffect(() => {
    document.title = title;
    upsertMeta('name', 'robots', robots);
    if (robots !== 'index, follow') {
      removeLink('canonical');
      upsertJsonLd('ld-business', null);
      upsertJsonLd('ld-page', null);
      upsertJsonLd('ld-faq', null);
    }
  }, [title, robots]);
  return null;
}